import styled from "styled-components";
import { Col as RCol, Row as RRow } from 'rsuite';

export const Col = styled(RCol)`
    color: ${({ theme, isSelected }) => isSelected ? theme.colors.white : theme.colors.text};
`

export const Row = styled(RRow)`
    display: flex;
    align-items: center;
    background-color: ${({ theme, isSelected }) => isSelected ? theme.colors.primary : theme.colors.backgroundSecondary};
    opacity: 1;
    padding: 10px 12px;
    border-radius: 10px;
    margin-bottom: 6px;
    cursor: ${({ isDragging, isManaging }) => !isManaging ? 'auto' : isDragging ? 'grabbing' : 'grab'};
    transition: box-shadow 0.15s ease, transform 0.1s ease;
    box-shadow: ${({ isDragging }) => isDragging
        ? '0 8px 20px rgba(0,0,0,0.18)'
        : '0 1px 3px rgba(0,0,0,0.07)'};
    transform: ${({ isDragging }) => isDragging ? 'scale(1.02)' : 'scale(1)'};

    &:hover {
        box-shadow: 0 3px 10px rgba(0,0,0,0.12);
    }
`

export const EditTamanho = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    width: 28px;
    height: 28px;
    border-radius: 6px;
    transition: background-color 0.15s ease;

    &:hover {
        background-color: ${({ theme }) => theme.colors.lightGray}60;
    }
`;
